// extracted by mini-css-extract-plugin
module.exports = {"headline":"_3LoVd","title":"_2NsyK","continue_shopping":"_3Xx8r","continueShopping":"_3Xx8r","caret":"xF03O"};